/**
 * Dashboard branding — the repo's default look-and-feel, centralised.
 *
 * The design *tokens* (colors, radius, fonts, risk/finality palettes) live in
 * `@authe/ui-core`'s Tailwind theme; tenant overrides come through the JWT and
 * are applied by `<TenantProvider>`. This module only carries the few app-level
 * brand defaults the dashboard ships with before any tenant override loads.
 */
import { DEFAULT_BRAND_IDENTITY, portalBrand } from "@authe/fe-commons/theme";

export const DEFAULT_BRAND = {
  ...DEFAULT_BRAND_IDENTITY,
  ...portalBrand("dashboard"),
  tagline: "Blockchain Compliance & Forensics",
};
export const APP_NAME = DEFAULT_BRAND.name;
export const APP_TAGLINE = DEFAULT_BRAND.tagline;

/** localStorage key for the persisted light/dark/system preference. */
export const THEME_STORAGE_KEY = "dashboard-theme";
